import lozad from "lozad";

function initLazyLoading() {
    this.$nextTick(() => {
        const observer = lozad('.lozad', {
            load: function (element) {
                const isIE = typeof document !== 'undefined' && document.documentMode;
                if (element.nodeName.toLowerCase() === 'picture') {
                    const img = document.createElement('img');
                    if (isIE && element.getAttribute('data-iesrc')) {
                        img.src = element.getAttribute('data-iesrc');
                    }

                    if (element.getAttribute('data-alt')) {
                        img.alt = element.getAttribute('data-alt');
                    }

                    if (typeof element.append === 'function' && element.append) {
                        element.append(img);
                    }

                    img.addEventListener('load', () => {
                        if (_.get(element, 'parentElement.classList')) {
                            element.parentElement.classList.add('loaded');
                        }
                    })
                }

                if (element.getAttribute('data-src')) {
                    element.src = element.getAttribute('data-src');
                }

                if (element.getAttribute('data-srcset')) {
                    element.setAttribute('srcset', element.getAttribute('data-srcset'));
                }

                if (element.getAttribute('data-background-image')) {
                    element.style.backgroundImage = `url('${element.getAttribute('data-background-image').split(',').join('\'),url(\'')}')`;
                } else if (element.getAttribute('data-background-image-set')) {
                    const imageSetLinks = element.getAttribute('data-background-image-set').split(',');
                    let firstUrlLink = (imageSetLinks[0].substr(0, imageSetLinks[0].indexOf(' ')) || imageSetLinks[0]); // Substring before ... 1x
                    firstUrlLink = firstUrlLink.indexOf('url(') === -1 ? `url(${firstUrlLink})` : firstUrlLink;
                    if (imageSetLinks.length === 1) {
                        element.style.backgroundImage = firstUrlLink;
                    } else {
                        element.setAttribute('style', (element.getAttribute('style') || '') + `background-image: ${firstUrlLink}; background-image: -webkit-image-set(${imageSetLinks}); background-image: image-set(${imageSetLinks})`);
                    }
                }

                if (element.getAttribute('data-toggle-class')) {
                    element.classList.toggle(element.getAttribute('data-toggle-class'));
                }
            }
        });
        observer.observe();
    });
}


export default {
    methods: {
        initLazyLoading,
    }
}
